import styled from 'styled-components'
import React from 'react'
import PropTypes from 'prop-types'

import { P2, B1, P5 } from '../Typo'

const LabelWeb = styled(B1)`
word-wrap: break-word;
max-width: 240px; /* NOTE: Hardcoded sensible default max width added to handle scenario of huge text strings in value */
`

const ValueWeb = styled(P5)`
  color: ${props => props.theme.palette.grey3};
`

const StyledB1 = styled(B1)`
  color: ${props => (props.color ? props.color : props.theme.palette.black3)};
`

const LabelValueWeb = ({ label, values, children, color, ...rest }) => {
  return (
    <div {...rest}>
      <LabelWeb>{label}</LabelWeb>
      {values ? typeof values === 'object' ? values.map(value => <ValueWeb>{value}</ValueWeb>) : <ValueWeb>{values}</ValueWeb> : ''}
      <StyledB1 color={color}>{children}</StyledB1>
    </div>
  )
}

LabelValueWeb.propTypes = {
  label: PropTypes.string,
  color: PropTypes.string,
  values: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
}

export default LabelValueWeb
